import React, { KeyboardEvent } from 'react'
import { Col, FormControl } from 'react-bootstrap'

import CountryPicker from '../../../../../../CountryPicker'
import Field from '../../../../../../Field'
import { IFilterType } from '../../../../../types'

const FulltextType = (props: IFilterType): React.ReactElement => {
  const { filter = {}, isMobile, index, handleKeyDown } = props

  if (filter.name === 'country') {
    return (
      <Col
        md={!isMobile ? (filter.colWidth ? filter.colWidth : 6) : 2}
        key={index}
      >
        <Field name={filter.name}>
          <CountryPicker
            hideLabel
            useShortCode
            direct
            customPlaceHolder={i18n.t(`country`, `Land`)}
          />
        </Field>
      </Col>
    )
  }

  return (
    <Col
      md={
        filter.type === 'fulltext'
          ? 12
          : !isMobile
          ? filter.colWidth
            ? filter.colWidth
            : 6
          : 2
      }
      xs={filter.mobileColWidth || 6}
      key={index}
    >
      <Field name={filter.name as string}>
        <FormControl
          placeholder={`${filter.label}`}
          onKeyDown={(e: KeyboardEvent<HTMLInputElement>) =>
            handleKeyDown && handleKeyDown(e)
          }
          autoFocus={
            filter.autoFocus || filter.type === 'fulltext' ? true : undefined
          }
        />
      </Field>
    </Col>
  )
}

export default FulltextType
